import {
  AfterViewInit,
  DestroyRef,
  Directive,
  ElementRef,
  effect,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[andorTextTicker]',
  standalone: true,
})
export class TextTickerDirective implements AfterViewInit {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);
  private observer?: ResizeObserver;

  readonly text = input<string>('', { alias: 'andorTextTicker' });

  constructor() {
    effect(() => {
      this.text();
      queueMicrotask(() => this.measure());
    });
    this.destroyRef.onDestroy(() => this.observer?.disconnect());
  }

  ngAfterViewInit(): void {
    this.observer = new ResizeObserver(() => this.measure());
    this.observer.observe(this.host.nativeElement);
    const inner = this.host.nativeElement.querySelector('.ticker-text');
    if (inner) this.observer.observe(inner);
    this.measure();
  }

  private measure(): void {
    const el = this.host.nativeElement;
    const inner = el.querySelector('.ticker-text') as HTMLElement | null;
    if (!inner) return;
    const overflow = inner.scrollWidth - el.clientWidth;
    if (overflow > 0) {
      el.classList.add('is-overflowing');
      el.style.setProperty('--ticker-offset', `-${overflow}px`);
      el.style.setProperty('--ticker-duration', `${Math.max(3, overflow / 20)}s`);
    } else {
      el.classList.remove('is-overflowing');
      el.style.removeProperty('--ticker-offset');
      el.style.removeProperty('--ticker-duration');
    }
  }
}
